import { cx } from 'cvb';
import PropTypes from 'prop-types';
import constants from '../../config/constants';
import { withLabels } from '../../utils/LabelsContext';
import { VariantAvailabilityOptionsStyles } from './VariantAvailabilityOptions.style';

const VariantAvailabilityOptions = ({ deviceType, labels, isHomeDeliveryAvailable, isPickFromStoreAvailable }) => {
  const deliveryAvailability = isHomeDeliveryAvailable
    ? {
        availability: 'deliveryAvailable',
        label: labels.TYPE_C_HOME_DELI_TITLE_MKP,
      }
    : {
        availability: 'deliveryNotAvailable',
        label: labels.TYPE_C_HOME_DELI_OUTOFSTOCK_MKP,
      };

  const pickupInStoreAvailability = isPickFromStoreAvailable
    ? {
        availability: 'pickupInStoreAvailable',
        label: labels.TYPE_C_PICKUP_INSTORE_TITLE_MKP,
      }
    : {
        availability: 'pickupInStoreNotAvailable',
        label: labels.TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP,
      };

  const alignItem = isHomeDeliveryAvailable && isPickFromStoreAvailable ? 'baseline' : '';
  const noDeliverybutAvailable = !isHomeDeliveryAvailable && isPickFromStoreAvailable ? 'noDeliverybutAvailable' : '';
  const iconClass = 'icon-mkp';
  return (
    <ul className={`availability-options mkp ${alignItem} ${noDeliverybutAvailable}`}>
      <li className={cx('availability-options-item', !isHomeDeliveryAvailable && 'disabled')}>
        <span className={`${iconClass} ${deliveryAvailability.availability}`} />
        {deviceType === 'desktop' && deliveryAvailability.label}
      </li>
      <li className={cx('availability-options-item', !isPickFromStoreAvailable && 'disabled')}>
        <span className={`${iconClass} ${pickupInStoreAvailability.availability}`} />
        {deviceType === 'desktop' && pickupInStoreAvailability.label}
      </li>
      <style jsx>{VariantAvailabilityOptionsStyles}</style>
    </ul>
  );
};

VariantAvailabilityOptions.defaultProps = {
  deviceType: constants.DEVICE_DESKTOP,
};

VariantAvailabilityOptions.propTypes = {
  labels: PropTypes.object.isRequired,
  deviceType: PropTypes.string,
  isHomeDeliveryAvailable: PropTypes.bool.isRequired,
  isPickFromStoreAvailable: PropTypes.bool.isRequired,
};

export { VariantAvailabilityOptions };

export default withLabels(VariantAvailabilityOptions);
